import RiskModelDetailView from './RiskModelDetailView';

export default RiskModelDetailView;
